import { render, staticRenderFns } from "./TopPc.vue?vue&type=template&id=28671d4a&scoped=true&"
import script from "./TopPc.vue?vue&type=script&lang=js&"
export * from "./TopPc.vue?vue&type=script&lang=js&"
import style0 from "./TopPc.vue?vue&type=style&index=0&id=28671d4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28671d4a",
  null
  
)

export default component.exports